
export type PageDto<T> = {
    page: number,
    size: number,
    totalElements: number,
    data: T[]
}

export function emptyPageDto<T>(): PageDto<T> { return { data: [], page: 0, size: 0, totalElements: 0 }
}